var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"selection-button",class:{ enabled: _vm.enabled }},[_c('div',{staticClass:"first-line"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('div',{staticClass:"second-line"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }